import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.414.487C4.414.217 4.63 0 4.9 0h6.4c.27 0 .487.218.487.487v2.948h3.827a.487.487 0 1 1 0 .973h-1.322v11.105a.487.487 0 0 1-.487.487H2.535a.487.487 0 0 1-.487-.487V4.408H.587a.487.487 0 1 1 0-.973h3.827zm.973 2.948h5.427V.973H5.387zm-2.365.973v10.619h10.296V4.408zm2.785 2.891a.487.487 0 0 1 .688-.002L8.1 8.889l1.606-1.592a.487.487 0 0 1 .685.69l-1.6 1.587 1.6 1.587a.487.487 0 1 1-.685.69L8.1 10.26l-1.605 1.592a.487.487 0 0 1-.685-.691l1.6-1.587-1.6-1.586a.487.487 0 0 1-.003-.689",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }